import { render, staticRenderFns } from "./modal-folder-update.vue?vue&type=template&id=597fea3c&"
import script from "./modal-folder-update.vue?vue&type=script&lang=js&"
export * from "./modal-folder-update.vue?vue&type=script&lang=js&"
import style0 from "./modal-folder-update.vue?vue&type=style&index=0&id=597fea3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports